<template>
    <!-- 教学管理 -->
    <div id="AssessmentDetail">
        <el-table
            :data="tableData"
            ref="CourseData"
            tooltip-effect="dark"
            style="width: 100%"
        >
            <el-table-column
                label="编号"
                type="index"
                min-width="60"
                :index="indexMethod"
            >

            </el-table-column>
            <el-table-column
                prop="name"
                label="班级"
                show-overflow-tooltip
                min-width="50"
            >
                <template slot-scope="scope">
                    <a>{{scope.row.name}}</a> <span
                        v-if="scope.row.shortTraining"
                        style="color:#e4393c;font-size:14px;"
                    >(短训班)</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="periodNames"
                label="上课时间"
            >
                <template slot-scope="scope">
                    <span v-if="scope.row.shortTraining">
                        <el-tooltip
                            :content="scope.row.periodNames"
                            placement="right"
                        >
                            <span>{{scope.row.shortTrainingStart | formatDate}}到{{scope.row.shortTrainingEnd | formatDate}}</span>
                        </el-tooltip>
                    </span>
                    <span v-else>{{scope.row.periodNames}}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="classRoomName"
                label="教室"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="teacherNames"
                label="任课老师"
                show-overflow-tooltip
            >
                <template>
                    <span>{{teacherName}}</span>
                </template>
            </el-table-column>

        </el-table>
        <div class="assement-main">
            <div class="assement-title">评估内容</div>
            <div class="a-i-item">
                <div
                    class="i-items"
                    :class="item.type=='1'?'i-star':''"
                    v-for="(item,index) in assForm.evaluationItems"
                    :key="index"
                >
                    <div class="i-t">{{item.name}} <span v-if="item.mustFill" >*</span></div>
                    <ul
                        class="star"
                        v-if="item.type=='1'"
                    >
                        <li
                            v-for="(itemClass,indexs) in item.list"
                            class="star-item"
                            @click="stars(indexs,index)"
                            :key="indexs"
                        >
                            <img :src="item.num>indexs?on:off" />
                        </li>
                    </ul>
                    <div
                        v-if="item.type=='1'"
                        style="color:red;"
                    >{{item.score}}分</div>
                    <textarea
                        v-model="item.content"
                        v-else-if="item.type=='2'"
                    ></textarea>
                </div>
            </div>
        </div>
        <div class="footer">
            <el-button
                type="primary"
                size="medium"
                @click="confirm"
            >提交</el-button>
            <el-button
                size="medium"
                @click="cancel"
            >取消</el-button>
        </div>
    </div>
</template>

<script>
import on from "@/assets/images/icon/star_on.png";
import off from "@/assets/images/icon/star_off.png";
export default {
    name: "confirm",

    data() {
        return {
            RecordData: [],
            isFirstEnter: false,
            score: 0,
            on: on,
            off: off,
            teacherName: "",
            assForm: {
                sheetId: "",
                classId: "",
                teacherId: "",
                evaluationItems: [],
            },
            tableData: [],
            itemData: [],
            assitemForm: {
                id: "",
            },
        };
    },
    filters: {
        formatDate: function (value) {
            let date = new Date(parseInt(value));
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            let h = date.getHours();
            h = h < 10 ? "0" + h : h;
            let m = date.getMinutes();
            m = m < 10 ? "0" + m : m;
            let s = date.getSeconds();
            s = s < 10 ? "0" + s : s;
            return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
        },
    },
    async created() {
        this.$global.activeMenu = "3-2";
    },
    async mounted() {
        let data = JSON.parse(this.$route.query.orderdatas);
        let index = this.$route.query.index;
        this.tableData.push(data);

        await this.loadAllItemData();
        this.assitemForm.id = data.templateId;
        this.assForm.sheetId = data.sheetId;
        this.assForm.classId = data.id;
        this.assForm.teacherId = data.teacherDatas[index].id;
        this.teacherName = data.teacherDatas[index].teacherName;
        await this.queryTeachingEvaluationSheetById(this.assitemForm);
    },
    computed: {
        calsses() {
            let result = [];
            let score = Math.floor(this.score * 2) / 2;
            let hasDecimal = score % 1 !== 0;
            let integer = Math.floor(score);
            for (let i = 0; i < integer; i++) {
                result.push("on");
            }
            if (hasDecimal) {
                result.push("half");
            }
            while (result.length < 5) {
                // 余下的用无星星补全,使用off
                result.push("off");
            }
            return result;
        },
    },

    watch: {},
    methods: {
        indexMethod(index) {
            return (index += 1);
        },
        async confirm() {
            let me = this;
            let iscan = false;
            try {
                me.assForm.evaluationItems.forEach(function (item, index) {
                    if (item.mustFill) {
                        if (item.type == "1") {
                            if (!item.score) {
                                me.$message({
                                    message: "请评分",
                                    type: "warning",
                                });
                                throw new Error();
                            }
                        }
                        if (item.type == "2") {
                            if (!item.content) {
                                me.$message({
                                    message: "请填写评价内容",
                                    type: "warning",
                                });
                                throw new Error();
                            }
                        }
                    }

                    if (index == me.assForm.evaluationItems.length - 1) {
                        iscan = true;
                    }
                });
            } catch (e) {}

            if (iscan) {
                let param = me.assForm;
                let res = await me.$userService.estimate(param);
                if (res.success) {
                    me.$message({
                        message: "保存成功",
                        type: "success",
                    });
                    me.$router.replace({ name: "Assessment" });
                }
            }
        },
        cancel() {
            this.$router.replace({
                name: "Assessment",
            });
        },
        loadAllItemData: async function () {
            let me = this;
            let param = {
                pageIndex: 1,
                pageSize: 9999,
            };
            let res = await this.$team.queryTeachingEvaluationItem(param);
            if (res.success) {
                me.itemData = res.content.records;
            }
        },
        stars: function (indexs, index) {
            this.assForm.evaluationItems[index].num = indexs + 1;
            this.assForm.evaluationItems[index].score = (
                (this.assForm.evaluationItems[index].fraction / 5) *
                (indexs + 1)
            ).toFixed(2);
        },
        // 处理每页显示数量
        handleSizeChange(val) {
            this.pageIndex = 1;
            this.pageSize = val;
        },
        // 处理翻页
        handleCurrentChange(val) {
            this.pageIndex = val;
        },

        async queryTeachingEvaluationSheetById(param) {
            let me = this;
            let res = await me.$userService.queryTeachingEvaluationSheetById(
                param
            );
            if (res && res["success"]) {
                let items = res.content.items;
                items.forEach((item, index) => {
                    let obj = me.itemData.find((list) => {
                        return list.id == item.teachingEvaluationItemId;
                    });
                    if (obj != undefined) {
                        me.assForm.evaluationItems.push({
                            itemId: item.teachingEvaluationItemId,
                            score: 0,
                            type: obj.type,
                            content: "",
                            fraction: obj.fraction,
                            num: 0,
                            list: [0, 1, 2, 3, 4],
                            name: obj.name,
                            mustFill:item.mustFill
                        });
                    }
                });
            }
        },
    },
};
</script>

<style lang="scss">
@import "../../assets/less/global.less";
@import "../../assets/css/icon.css";
@import "../../assets/css/app.css";
#AssessmentDetail {
    padding: 30px;
    .assement-title {
        font-size: 20px;
        width: 160px;
        margin: 20px 0;
        height: 40px;
        color: #fff;
        background: #1386d3;
        line-height: 40px;
        text-align: center;
        border-top-right-radius: 30px;
        border-bottom-right-radius: 30px;
    }
    .footer {
        margin: 40px 0;
        text-align: center;
        .el-button {
            margin: 0 30px;
        }
    }
    .i-star {
        display: flex;
        align-items: center;
    }
    .a-i-item {
        padding: 0px 20px;
        box-sizing: border-box;
        margin-bottom: 10px;
        .i-items {
            margin: 10px 0;
            font-size: 16px;
            font-weight: bold;
            border-bottom: 1px dashed #e7e9ec;
            span {
                color: #ff6600;
            }
            textarea {
                margin: 5px 0;
                padding: 10px;
                font-size: 16px;
                border: none;
                outline: none;
                width: 100%;
                min-height: 40px;
                border: 1px solid #e7e9ec;
                border-radius: 5px;
            }
            .star {
                margin: 10px 0;
                margin-left: 60px;
            }
            ul {
                padding: 0px;
                margin: 0px;
                li {
                    margin: 0 10px;
                    width: 40px;
                    height: 40px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }
        .i-items:last-child {
            border-bottom: none;
        }
    }
    .star {
        font-size: 0;
    }
    .star-item {
        display: inline-block;
        background-repeat: no-repeat;
        width: 0.6rem;
        height: 0.6rem;
        margin-left: 0.27rem;
        background-size: 100%;
    }
    .star-item.on {
        background-image: url(../../assets/images/icon/star_on.png);
    }
    .star-item.off {
        background-image: url(../../assets/images/icon/star_off.png);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Assessment/AssessmentDetail.vue